import React, { useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { ErrorMessage, Form, Formik } from "formik";
import { takeSnapshopAndCreateTemplate } from "../../_actions/storiesActions";
import { wsStatusMessage } from "../../_middleware/middleware";
import {
  Button,
  ButtonGroup,
  Divider,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function TldrCreateComponent(props) {
  const { t } = useTranslation(["studio", "common"]);
  let signal = axios.CancelToken.source();
  const { show, onHide } = props;
  useEffect(() => {
    return () => {
      signal.cancel("The user aborted a request.");
    };
  }, [signal]);

  const CreateComponent = ({ parentProps, signal }) => (
    <Formik
      initialValues={{ name: "My component" }}
      validate={(values) => {
        const errors = {};
        if (!values.name) {
          errors.name = t("tldr_create_component.valid_name_err");
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        takeSnapshopAndCreateTemplate(values.name, parentProps, signal)
          .then(() => {
            setSubmitting(false);
            parentProps.onHide();
          })
          .catch((error) => {
            setSubmitting(false);
            setErrors({
              name: t("tldr_create_component.something_wrong_err"),
            });
          });
      }}
    >
      {({ isSubmitting, values, handleChange, handleBlur }) => (
        <Form>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="4">
              {isSubmitting
                ? t("tldr_create_component.modal_title_create")
                : t("tldr_create_component.modal_title_save")}
            </ModalHeader>
            <ModalCloseButton />
            <Divider my="0" />
            <ModalBody p="4">
              <Text>
                {isSubmitting
                  ? t("tldr_create_component.modal_body_create_loading")
                  : t("tldr_create_component.modal_body_create")}
              </Text>

              <InputGroup mt="3">
                <Input
                  type="text"
                  name="name"
                  placeholder={t("tldr_create_component.input_placeholder")}
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              <ErrorMessage name="name" component="div" className="error" />
            </ModalBody>
            <Divider my="0" />

            <ModalFooter p="3">
              <ButtonGroup>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    parentProps.onHide();
                  }}
                  variant="secondary"
                  colorScheme="primary"
                  disabled={isSubmitting}
                  mr={2}
                >
                  {t("cancel", { ns: "common" })}
                </Button>

                <Button
                  type="submit"
                  colorScheme="primary"
                  variant="solid"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  {t("tldr_create_component.modal_save_now_btn")}
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      )}
    </Formik>
  );

  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <CreateComponent parentProps={props} signal={signal}></CreateComponent>
    </Modal>
  );
}

TldrCreateComponent.propTypes = {};

const mapStateToProps = (state) => {
  return {
    editor: state.editor,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    wsStatusMessage: (message) => dispatch(wsStatusMessage(message)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TldrCreateComponent);
